"use client"
import Image from "next/image";
import Link from "next/link"
import mentors from "@/constatns/mentors"
import React, { useEffect } from "react";
import { DropdownMenu, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuTrigger, } from "@/components/dropDown"
import CrossIcon from "../../../public/icons/cross.svg";
import ChevronDown from "../../../public/icons/chevronDown.svg"
import NotFoundIcon from "../../../public/icons/not-fount.svg"
import UnsureIcon from "../../../public/icons/unsure.svg"
import { Person } from "@/types/mentor"
import { useRouter, useSearchParams } from "next/navigation";
import Head from "next/head";


export default function Page() {
    let locations: string[] = []
    let languages: any[] = [];
    let categories: string[] = []
    mentors.forEach(mentor => {
        mentor.location.forEach(country => {
            if (!locations.includes(country)) {
                locations.push(country)
            }
        })

        mentor.background.languages.forEach((language) => {
            if (!languages.includes(language)) {
                languages.push(language)
            }
        });

        if (!categories.includes(mentor.background.expertise)) {
            categories.push(mentor.background.expertise)
        }
    })

    const [selectLocations, setSelectLocations] = React.useState<string[]>([])
    const [selectLanguages, setSelectLanguages] = React.useState<string[]>([])
    const [selectCategories, setSelectCategories] = React.useState<string[]>([])
    const [currentMentors, setCurrentMentors] = React.useState<Person[]>(mentors)

    const searchParams = useSearchParams();
    const router = useRouter();

    const clearAllFilters = () => {
        setSelectLocations([])
        setSelectLanguages([])
        setSelectCategories([])
    }

    const upperCaseFirstLetter = (input: string): string => {
        return input.charAt(0).toUpperCase() + input.slice(1)
    }

    const updateUrl = (updateLocation: string[] = selectLocations, updateCategory: string[] = selectCategories, updateLanguage: string[] = selectLanguages) => {
        const joinLocations = updateLocation.join(',');
        const newUrl = `/mentors?${updateLocation.length > 0 ? "location=" + joinLocations : ''}${updateCategory.length > 0 ? "&category=" + updateCategory : ''}${updateLanguage.length > 0 ? "&language=" + updateLanguage : ''}`;
        // @ts-ignore
        router.push(newUrl, undefined, { shallow: true })
    }

    useEffect(() => {
        const locationQuery = searchParams?.get('location') || '';
        const categoryQuery = searchParams?.get('category') || '';
        const languageQuery = searchParams?.get('language') || '';

        let splitLocationQuery = locationQuery.split(',');
        let splitCategoryQuery = categoryQuery.split(',');
        let splitLanguageQuery = languageQuery.split(',');

        splitLocationQuery = splitLocationQuery.map(item => upperCaseFirstLetter(item))
        splitCategoryQuery = splitCategoryQuery.map(item => upperCaseFirstLetter(item))
        splitLanguageQuery = splitLanguageQuery.map(item => upperCaseFirstLetter(item))

        const locationsQuery = splitLocationQuery[0] === '' ? [] : splitLocationQuery
        const categoriesQuery = splitCategoryQuery[0] === '' ? [] : splitCategoryQuery
        const languagesQuery = splitLanguageQuery[0] === '' ? [] : splitLanguageQuery

        setSelectLocations([...locationsQuery])
        setSelectCategories([...categoriesQuery])
        setSelectLanguages([...languagesQuery])
    }, [searchParams])

    useEffect(() => {
        let filterMentor: Person[] = []
        let filterCounter = 0

        if (selectCategories.length > 0) {
            let hasEffectiveFilter = false
            for (let i = 0; i < selectCategories.length; i++) {
                const category = selectCategories[i]
                const filterByCategory = mentors.filter((mentor) => mentor.background.expertise === category);
                if (filterByCategory.length < mentors.length) {
                    filterMentor = [...filterMentor, ...filterByCategory];
                    hasEffectiveFilter = true
                }
            }
            if (hasEffectiveFilter) filterCounter++;
        }

        // if (selectLanguages.length > 0) {
        //     let hasEffectiveFilter = false
        //     for (let i = 0; i < selectLanguages.length; i++) {
        //         const language = selectLanguages[i]
        //         const filterByLanguage = mentors.filter((mentor) => mentor.background.languages.includes(language));
        //         if (filterByLanguage.length < mentors.length) {
        //             filterMentor = [...filterMentor, ...filterByLanguage];
        //             hasEffectiveFilter = true
        //         }
        //     }
        //     if (hasEffectiveFilter) filterCounter++;
        // }

        if (selectLocations.length > 0) {
            let hasEffectiveFilter = false
            for (let i = 0; i < selectLocations.length; i++) {
                const location = selectLocations[i]
                const filterByLocation = mentors.filter((mentor) => mentor.location.includes(location));
                if (filterByLocation.length < mentors.length) {
                    filterMentor = [...filterMentor, ...filterByLocation];
                    hasEffectiveFilter = true
                }
            }
            if (hasEffectiveFilter) filterCounter++;
        }

        if (selectLocations.length > 0 || selectCategories.length > 0) {
            if (filterCounter == 1) {
                filterMentor = [...filterMentor, ...mentors]
            }

            let temp: Person[] = []
            let dup: Person[] = []

            const result = filterMentor.filter((item, _, arr) => arr.filter(x => x === item).length > (filterCounter - 1));

            for (let i = 0; i < result.length; i++) {
                const item = result[i]
                if (temp.includes(item) && !dup.includes(item)) {
                    dup.push(item)
                } else {
                    temp.push(item)
                }
            }

            setCurrentMentors(dup)
        }

        if (selectLocations.length === 0 && selectCategories.length === 0) {
            setCurrentMentors(mentors)
        }
    }, [selectLocations, selectLanguages, selectCategories])

    return (
        <>
            <Head>
                <title>Mentors</title>
                <link rel="canonical" href="https://expatpie.com/mentors" />
                <meta property="og:title" content="Mentors" />
                <meta property="og:site_name" content="Expat Pie" />
                <meta property="og:description" content="Connect with mentors who have successfully relocated and work in top tech companies. Find the perfect fit to guide you every step of the way." />
                <meta property="og:url" content="https://expatpie.com/mentors" />
                <meta name="description" content="Connect with mentors who have successfully relocated and work in top tech companies. Find the perfect fit to guide you every step of the way." />
            </Head>
            <main className="min-h-screen">
                <div className="flex flex-col items-center py-11 lg:py-16">
                    <div className="lg:w-4/5 lg:max-w-[1190px] lg:px-0">
                        <div className="px-9 lg:px-0">
                            <h1 className="text-42 text-white font-semibold font-barlow">Mentors</h1>
                            <p className="mt-3 text-white-50 font-normal text-lg">
                                Skilled in product management, development, design, etc
                            </p>
                        </div>
                        <div className="mt-11 lg:mt-8">
                            <div
                                className="flex lg:justify-between lg:items-start items-center flex-col-reverse lg:flex-row">
                                {currentMentors.length ?
                                    <div className="lg:w-4/6 flex lg:items-start items-center flex-col">
                                        <a href="https://calendar.app.google/uKzH4f4sNiFKSq9j8" target="_blank" className="lg:w-full group bg-gradian-accent py-3 px-4 lg:mx-0 mx-9 flex items-center lg:mb-12">
                                            <UnsureIcon className="w-8 h-8 min-w-8" />
                                            <div className="pl-4">
                                                <p className="text-lg font-inter font-semibold text-white-100">​Schedule Your Free 15 Minute Session Today</p>
                                                <p className="text-sm font-inter text-white-80 mt-2">Limited slot available. Book now!</p>
                                            </div>
                                        </a>
                                        <ul className="lg:w-full mt-6 lg:mt-0 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 sm:gap-x-14 gap-y-11 lg:gap-y-12 px-9 lg:px-0">
                                            {currentMentors.map((item) => <li className="max-w-[200px]" key={item.id}>
                                                {/*<Mentor link={`/mentor/${item.fullName.toLowerCase().split(" ").join("-")}`}*/}
                                                {/*imgSrc={`/images/mentors/${item.fullName.toLowerCase().split(" ").join("-")}.jpg`}*/}
                                                {/*firstName={item.fullName.split(" ")[0]}*/}
                                                {/*lastName={item.fullName.split(" ")[1]}*/}
                                                {/*jobTitle={item.jobTitle} />*/}
                                                <Link href={`/mentor/${item.fullName.toLowerCase().split(" ").join("-")}`}
                                                    className="flex flex-col">
                                                    <div className="relative">
                                                        <div className="overflow-hidden">
                                                            <Image
                                                                className="hover:scale-110 transition duration-300 ease-in-out"
                                                                src={`/images/mentors/${item.fullName.toLowerCase().split(" ").join("-")}.jpg`}
                                                                alt="mentor"
                                                                width={200}
                                                                height={260}
                                                                quality={75}
                                                                placeholder="blur"
                                                                loading="lazy"
                                                                blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mMUqwcAALEAlw+6NSgAAAAASUVORK5CYII="
                                                            />
                                                        </div>
                                                        <div
                                                            className="absolute bg-gradient-to-b from-blur-0 to-blur-100 lg:w-full h-1/5 -bottom-px w-[101%] -left-px lg:left-0">
                                                        </div>
                                                        <p className="text-32 font-bold font-barlow text-white-90 absolute bottom-0">{item.fullName.split(" ")[0]}</p>
                                                    </div>
                                                    <div className="text-left">
                                                        {/*<p className="text-32 font-bold text-white-90">{item.fullName.split(" ")[0]}</p>*/}
                                                        <p className="text-32 font-bold text-white-90 font-barlow leading-none">{item.fullName.split(" ")[1]}</p>
                                                        <p className="text-lg font-normal text-white-50 mt-5">{item.jobTitle}</p>
                                                    </div>
                                                </Link>
                                            </li>)}
                                        </ul></div> : ''}
                                {!currentMentors.length ?
                                    <div className="lg:w-4/6 flex flex-col items-center justify-center pt-28">
                                        <NotFoundIcon />
                                        <p className="mt-12 text-white-100 text-sm font-semibold text-center px-9 lg:px-0">
                                            No results found, check your filters again
                                        </p>
                                    </div> : ''}
                                {/*filter*/}
                                <div className="pb-5 lg:pb-0 lg:w-[29%] lg:sticky lg:top-44">
                                    <div
                                        className="overflow-x-scroll lg:overflow-x-hidden px-9 lg:px-0 lg:block max-w-[100vw] lg:max-w-xs lg:w-full">
                                        {/*<input type="text" placeholder="Name" className="bg-[#151515] px-2 py-2.5 w-full text-base text-white-68 outline-0" />*/}
                                        <div className="flex gap-5 lg:block">
                                            <div>
                                                <DropdownMenu>
                                                    <DropdownMenuTrigger asChild className="bg-dark-gray px-2 py-2.5">
                                                        <div className="flex justify-between items-center">
                                                            <div className="text-base text-white-68 mr-5">Location</div>
                                                            <ChevronDown />
                                                        </div>
                                                    </DropdownMenuTrigger>
                                                    <DropdownMenuContent className="border-0 rounded-none bg-dark-gray">
                                                        {locations.map((item, index) => <DropdownMenuCheckboxItem
                                                            key={index}
                                                            className="hover:bg-white-8 cursor-pointer min-w-fit lg:min-w-[310px] max-w-xs"
                                                            checked={selectLocations.includes(item)}
                                                            // onCheckedChange={setShowStatusBar}
                                                            onSelect={() => {
                                                                const itemIndex = selectLocations.indexOf(item)
                                                                if (itemIndex > -1) {
                                                                    const updateLocation = selectLocations.filter(country => country != item);
                                                                    updateUrl(updateLocation)
                                                                } else {
                                                                    const updateLocation = [...selectLocations, item];
                                                                    updateUrl(updateLocation)
                                                                }
                                                            }}
                                                        >
                                                            {item}
                                                        </DropdownMenuCheckboxItem>)}
                                                    </DropdownMenuContent>
                                                </DropdownMenu>
                                                {selectLocations.length > 0 &&
                                                    <ul className="mt-2.5 lg:flex lg:flex-wrap lg:gap-3.5 hidden">
                                                        {selectLocations.map((item, index) => <li
                                                            className="flex items-center bg-white-100 px-4 py-1.5 font-semibold text-sm text-darker"
                                                            key={index}>
                                                            {item}
                                                            <CrossIcon className="ml-1 cursor-pointer" onClick={() => {
                                                                const updateLocation = selectLocations.filter(country => country != item);
                                                                updateUrl(updateLocation)
                                                            }} />
                                                        </li>)}
                                                    </ul>}
                                            </div>
                                            <div className="lg:mt-12">
                                                <DropdownMenu>
                                                    <DropdownMenuTrigger asChild className="bg-dark-gray px-2 py-2.5">
                                                        <div className="flex justify-between items-center">
                                                            <div className="text-base text-white-68 mr-5">Language</div>
                                                            <ChevronDown />
                                                        </div>
                                                    </DropdownMenuTrigger>
                                                    <DropdownMenuContent className="border-0 rounded-none bg-dark-gray">
                                                        {languages.map((item, index) => <DropdownMenuCheckboxItem
                                                            key={index}
                                                            className="hover:bg-white-8 cursor-pointer min-w-fit lg:min-w-[310px] max-w-xs"
                                                            checked={selectLanguages.includes(item)}
                                                            // onCheckedChange={setShowStatusBar}
                                                            onSelect={() => {
                                                                const itemIndex = selectLanguages.indexOf(item)
                                                                if (itemIndex > -1) {
                                                                    const updateLanguages = selectLanguages.filter(lang => lang != item)
                                                                    updateUrl(selectLocations, selectCategories, updateLanguages)
                                                                } else {
                                                                    const updateLanguages = [...selectLanguages, item]
                                                                    updateUrl(selectLocations, selectCategories, updateLanguages)
                                                                }
                                                            }}
                                                        >
                                                            {item}
                                                        </DropdownMenuCheckboxItem>)}
                                                    </DropdownMenuContent>
                                                </DropdownMenu>
                                                {selectLanguages.length > 0 &&
                                                    <ul className="mt-2.5 lg:flex lg:flex-wrap lg:gap-3.5 hidden">
                                                        {selectLanguages.map((item, index) => <li
                                                            className="flex items-center bg-white-100 px-4 py-1.5 font-semibold text-sm text-darker"
                                                            key={index}>
                                                            {item}
                                                            <CrossIcon className="ml-1 cursor-pointer" onClick={() => {
                                                                const updateLanguage = selectLanguages.filter(lang => lang != item)
                                                                updateUrl(selectLocations, selectCategories, updateLanguage)
                                                            }} />
                                                        </li>)}
                                                    </ul>}
                                            </div>
                                            <div className="lg:mt-12">
                                                <DropdownMenu>
                                                    <DropdownMenuTrigger asChild className="bg-dark-gray px-2 py-2.5">
                                                        <div className="flex justify-between items-center">
                                                            <div className="text-base text-white-68 mr-5">Categories</div>
                                                            <ChevronDown />
                                                        </div>
                                                    </DropdownMenuTrigger>
                                                    <DropdownMenuContent className="border-0 rounded-none bg-dark-gray">
                                                        {categories.map((item, index) => <DropdownMenuCheckboxItem
                                                            key={index}
                                                            className="hover:bg-white-8 cursor-pointer min-w-fit lg:min-w-[310px] max-w-xs"
                                                            checked={selectCategories.includes(item)}
                                                            // onCheckedChange={setShowStatusBar}
                                                            onSelect={() => {
                                                                const itemIndex = selectCategories.indexOf(item)
                                                                if (itemIndex > -1) {
                                                                    const updateCategories = selectCategories.filter(category => category != item)
                                                                    updateUrl(selectLocations, updateCategories)
                                                                } else {
                                                                    const updateCategories = [...selectCategories, item]
                                                                    updateUrl(selectLocations, updateCategories)
                                                                }
                                                            }}
                                                        >
                                                            {item}
                                                        </DropdownMenuCheckboxItem>)}
                                                    </DropdownMenuContent>
                                                </DropdownMenu>
                                                {selectCategories.length > 0 &&
                                                    <ul className="mt-2.5 lg:flex flex-wrap gap-3.5 hidden">
                                                        {selectCategories.map((item, index) => <li
                                                            className="flex items-center bg-white-100 px-4 py-1.5 font-semibold text-sm text-darker"
                                                            key={index}>
                                                            {item}
                                                            <CrossIcon className="ml-1 cursor-pointer" onClick={() => {
                                                                const updateCategories = selectCategories.filter(category => category != item)
                                                                updateUrl(selectLocations, updateCategories)
                                                            }} />
                                                        </li>)}
                                                    </ul>}
                                            </div>
                                            {selectLocations.length > 0 || selectLanguages.length > 0 || selectCategories.length > 0 ?
                                                <button onClick={clearAllFilters}
                                                    className="hidden lg:block mt-12 border border-white text-base text-white font-semibold py-2.5 w-full">Clear
                                                    all filters</button> : ''}
                                        </div>
                                    </div>
                                    {selectLocations.length > 0 || selectLanguages.length > 0 || selectCategories.length > 0 ?
                                        <ul className="flex px-9 mt-5 lg:hidden gap-4 flex-wrap">
                                            {selectCategories.map((item, index) => <li
                                                className="flex items-center bg-white-100 px-4 py-1.5 font-semibold text-sm text-darker"
                                                key={index}>
                                                {item}
                                                <CrossIcon className="ml-1 cursor-pointer" onClick={() => {
                                                    const updateCategories = selectCategories.filter(category => category != item)
                                                    updateUrl(selectLocations, updateCategories)
                                                }} />
                                            </li>)}
                                            {selectLanguages.map((item, index) => <li
                                                className="flex items-center bg-white-100 px-4 py-1.5 font-semibold text-sm text-darker"
                                                key={index}>
                                                {item}
                                                <CrossIcon className="ml-1 cursor-pointer" onClick={() => {
                                                    const updateLanguage = selectLanguages.filter(lang => lang != item)
                                                    updateUrl(selectLocations, selectCategories, updateLanguage)
                                                }} />
                                            </li>)}
                                            {selectLocations.map((item, index) => <li
                                                className="flex items-center bg-white-100 px-4 py-1.5 font-semibold text-sm text-darker"
                                                key={index}>
                                                {item}
                                                <CrossIcon className="ml-1 cursor-pointer" onClick={() => {
                                                    const updateLocation = selectLocations.filter(country => country != item);
                                                    updateUrl(updateLocation)
                                                }} />
                                            </li>)}
                                            <li className="flex">
                                                <button onClick={clearAllFilters}
                                                    className="text-base text-white font-semibold text-nowrap flex items-center">
                                                    Clear all filters
                                                </button>
                                            </li>
                                        </ul> : ''}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}
